module.exports = __webpack_public_path__ + "img/apple.1c61821e.svg";